import React from 'react'
import { Box, Modal as MuiModal } from '@mui/material'

import WinScreen from '../pages/WinScreen'
import LoseScreen from '../pages/LoseScreen'
import { BetResult, PriceRange } from 'hooks/useDetailedBetResult'

interface ModalProps {
  open: boolean
  onClose: VoidFunction
  betResult: BetResult
  priceRange: PriceRange
  percentageChange: string
}

const Modal: React.FC<ModalProps> = ({
  open,
  onClose,
  betResult,
  priceRange,
  percentageChange,
}) => {
  return (
    <MuiModal
      open={open}
      onClose={onClose}
      aria-labelledby="fullscreen-popup-title"
      aria-describedby="fullscreen-popup-description"
      closeAfterTransition
    >
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: '#fff',
          animation: 'fadeIn 0.5s ease',
          '@keyframes fadeIn': {
            from: { opacity: 0 },
            to: { opacity: 1 },
          },
        }}
      >
        <Box
          sx={{
            padding: '20px',
            borderRadius: '8px',
            textAlign: 'center',
            height: '100%',
            transform: 'translateY(100%)',
            animation: 'slideIn 0.5s ease',
            '@keyframes slideIn': {
              from: { transform: 'translateY(100%)' },
              to: { transform: 'translateY(0)' },
            },
            animationFillMode: 'forwards',
          }}
        >
          {betResult === 'win' && (
            <WinScreen
              priceRange={priceRange}
              percentageChange={percentageChange}
            />
          )}

          {betResult === 'lose' && (
            <LoseScreen
              priceRange={priceRange}
              percentageChange={percentageChange}
            />
          )}
        </Box>
      </Box>
    </MuiModal>
  )
}

export default Modal
